import { useDispatch } from 'react-redux';
import { AppDispatch } from './configureStore';

// This is used to get the correct typings for our dispatches, so this should be used instead of the regular useDispatch export from react-redux
export const useAppDispatch: () => AppDispatch = useDispatch;
